import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
  apiCalcReversal,
  CalcReversalReq,
  CalcReversalRes,
  CalcReversalResult,
} from '../../api/selfApi'

export interface CalcReversalState {
  result: CalcReversalResult | undefined
  responseCode: number
  fetchState: 'initialize' | 'pending' | 'fulfilled' | 'rejected'
}

export const initialState: CalcReversalState = {
  result: undefined,
  responseCode: 0,
  fetchState: 'initialize',
}

// TODO ApiのstatusCodeによるエラー処理など
export const fetchCalcReversal = createAsyncThunk<CalcReversalRes, CalcReversalReq>(
  'calcReversal/fetchApi',
  async (arg) => {
    const response = await apiCalcReversal(arg)
    return response.payload
  }
)

export const calcReversal = createSlice({
  name: 'calcReversal',
  initialState,
  reducers: {
    reset: (state) => {
      return initialState
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCalcReversal.pending, (state, action) => {
      state.fetchState = 'pending'
    })
    builder.addCase(fetchCalcReversal.fulfilled, (state, action) => {
      state.fetchState = 'fulfilled'
      state.responseCode = action.payload.statusCode
      state.result = action.payload.result
    })
    builder.addCase(fetchCalcReversal.rejected, (state, action) => {
      state.fetchState = 'rejected'
      state.result = undefined
      state.responseCode = 20
    })
  },
})

export const { reset } = calcReversal.actions
